import { surveillanceService } from '../../services'

const initialState = { idCorrespondance: null, selectedVariable: null }

export const acquisition = {
    namespaced: true,
    state: initialState,
    getters: {
        idCorrespondance: (state) => {
            return state.idCorrespondance
        },
        selectedVariable: (state) => {
            return state.selectedVariable
        }
    },
    actions: {
        setSelectedVariable ({ commit }, { varGuid, varLibelle, breadcrumbs }) {
            commit('selectVariable', { varGuid, varLibelle, breadcrumbs })
        },
        unsetSelectedVariable ({ commit }) {
            commit('unselectVariable')
        },
        setCorrespondance ({ commit }, { id }) {
            commit('setIdCorrespondance', id)
        },
        unsetCorrespondance ({ commit }) {
            commit('unsetIdCorrespondance')
        }
    },
    mutations: {
        async selectVariable (state, { varGuid, varLibelle, breadcrumbs }) {
            // let unite = acquisitionService.getUniteAcquisition(varGuid)
            let dpsmData = await surveillanceService.getDpsmVariableData(varGuid)
            if (dpsmData !== null) {
                let unitesSerieType = await surveillanceService.getUnitesBySerieType(dpsmData.grandeurGuid)
                let uniteData = null
                for (let u in unitesSerieType) {
                    if (unitesSerieType[u].unitGuid === dpsmData.unitGuid) {
                        uniteData = unitesSerieType[u]
                    }
                }
                state.selectedVariable = {
                    col_number: null,
                    var_file_name: null,
                    var_guid: varGuid,
                    var_libelle: varLibelle,
                    serietype_guid: dpsmData.grandeurGuid,
                    unit_guid: dpsmData.unitGuid,
                    unit_libelle: uniteData.unitSymbol,
                    unit_description: uniteData.unitLibelle,
                    unit_serietype_list: unitesSerieType,
                    breadcrumbs_surveillance: breadcrumbs
                }
            }
        },
        unselectVariable (state) {
            state.selectedVariable = null
        },
        setIdCorrespondance (state, id) {
            state.idCorrespondance = id
        },
        unsetIdCorrespondance (state) {
            state.idCorrespondance = null
        }
    }
}
